import ValidationRegex from '../data/Utils.Data.ValidationRegex';

export default function getGoogleDocsPreviewUrl(url: string) {
  return `https://docs.google.com/gview?url=${
    ValidationRegex.absolutePath.test(url) ? document.location.origin : ''
  }${url}&embedded=true`;
}
